module.exports = __webpack_public_path__ + "fonts/Inter-500-greek-ext31.318d4ba.woff2";